
namespace GeniuzPOS.Administration {

    @Serenity.Decorators.registerClass()
    export class PsConfigTypeGrid extends Serenity.EntityGrid<PsConfigTypeRow, any> {
        protected getColumnsKey() { return PsConfigTypeColumns.columnsKey; }
        protected getDialogType() { return PsConfigTypeDialog; }
        protected getIdProperty() { return PsConfigTypeRow.idProperty; }
        protected getInsertPermission() { return PsConfigTypeRow.insertPermission; }
        protected getLocalTextPrefix() { return PsConfigTypeRow.localTextPrefix; }
        protected getService() { return PsConfigTypeService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}